import React from 'react'
import LoadingButton from '@mui/lab/LoadingButton';
import green from '@mui/material/colors/green'

const LoadingIconButton = ({ 
    title,
    onClick,
    icon,
    loading,
    size='medium'
}) => 
    <LoadingButton
        size={size}
        loading={loading}
        fullWidth
        loadingPosition="start"
        startIcon={icon}
        onClick={onClick}
        variant="contained"
        sx={{ 
            backgroundColor: green['A400'],
            '&:hover': {
                backgroundColor: green['A700'],
            },
        }}
        >
        {title}
    </LoadingButton>

export default LoadingIconButton

